import { useState } from 'react';
import { X, KeyRound } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { useLang } from '@/context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SetPasswordDialog = ({ client, token, onClose }) => {
  const [password, setPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const { t } = useLang();

  const save = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error(t('auth.min6')); return; }
    setSaving(true);
    try {
      await axios.put(`${API}/admin/clients/${client.id}/password`, { password }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(t('admin.password_updated', { name: client.name }));
      onClose();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? t(d) : t('admin.password_fail'));
    }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4" data-testid="set-password-dialog">
      <form onSubmit={save} className="w-full max-w-sm bg-[#121215] border border-[rgba(255,255,255,0.08)] rounded-lg p-6">
        <div className="flex items-start justify-between mb-5">
          <div>
            <h3 className="text-lg font-['Cormorant_Garamond'] font-bold text-[#F5F2EB] flex items-center gap-2">
              <KeyRound className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.5} /> {t('admin.set_password')}
            </h3>
            <p className="text-xs text-[#A3A19C] mt-1">{client.name} · {client.email}</p>
          </div>
          <button type="button" onClick={onClose} className="text-[#A3A19C] hover:text-[#F5F2EB]" data-testid="set-password-close"><X className="w-4 h-4" /></button>
        </div>
        <label className="block text-sm text-[#A3A19C] mb-2">{t('auth.new_pass')}</label>
        <input type="text" value={password} onChange={e => setPassword(e.target.value)} autoFocus data-testid="set-password-input"
          className="w-full bg-[#08080A] border border-[rgba(255,255,255,0.1)] rounded-lg px-4 py-3 text-[#F5F2EB] text-sm focus:outline-none focus:border-[#D4AF37] mb-5"
          placeholder={t('auth.ph_min6')} />
        <button type="submit" disabled={saving} className="w-full btn-primary" data-testid="set-password-submit">
          {saving ? t('common.saving') : t('admin.save_password')}
        </button>
      </form>
    </div>
  );
};
